import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (topic, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: topic.id
    }, [
      _withDirectives(_createElementVNode("p", {
        class: "clickable",
        onClick: 
        () => {
          _ctx.toggleTopic(topic, index);
        }
      
      }, null, 8, _hoisted_1), [
        [_directive_dompurify_html, topic.title]
      ]),
      _createElementVNode("span", null, _toDisplayString(topic.commentcount) + " Kommentare.", 1),
      _hoisted_2
    ]))
  }), 128))
}